<fieldset class="field-group-component" *ngIf="!hasRowValueGroup(field.config.id); else rowValueGroup">
  <legend *ngIf="field.label" class="bl-font-size--14 bl-margin-bottom--4 bl-font-weight--800" [class.bl-required]="field.required || field.config.required"
    [class.bl-screen-reader-only]="screenReaderOnly(field)">
    {{ field.label }}
  </legend>
  <div [ngClass]="formatter" [id]="field.id">
    <div class="field-group-wrapper" *ngFor="let nestedField of field.nestedFields">
      <cu-dynamic-field [page]="page" [card]="card" [field]="nestedField" [pageSubmitted$]="pageSubmitted$"  *ngIf="nestedField.visible"></cu-dynamic-field>
    </div>
  </div>
</fieldset>

<ng-template #rowValueGroup class="bl-margin-bottom--0">
  <div class="bl-font-color--steel bl-display--flex bl-margin-bottom--8">
    <span class="bl-width--50 bl-font-weight--800 bl-margin-right--24 bl-margin-bottom--0">
      {{field.label}}
    </span>
    <span class="bl-flex--auto bl-margin-bottom--0" [attr.aria-labelledby]="field.id">
      <ng-container *ngFor="let field of field.nestedFields">
        <span *ngIf="field.data.value && formatter !== 'block'">
          {{ field.readableValue | mask:field.config.mask }}
          {{ field.config.postfix? parse(field.config.postfix): '' }}
        </span>
      </ng-container>
    </span>
  </div>
</ng-template>
